import { useState, useRef, useCallback } from "react";

interface UseOtpTimerReturn {
	timeLeft: number;
	startTimer: (duration: number) => void;
	resetTimer: () => void;
	formatTime: (seconds: number) => string;
}

const useOtpTimer = (): UseOtpTimerReturn => {
	const [timeLeft, setTimeLeft] = useState<number>(0);
	const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

	const stopTimer = useCallback(() => {
		if (timerRef.current) {
			clearInterval(timerRef.current);
			timerRef.current = null;
		}
	}, []);

	const startTimer = useCallback(
		(duration: number) => {
			stopTimer();
			setTimeLeft(duration);
			timerRef.current = setInterval(() => {
				setTimeLeft((prev) => {
					if (prev <= 1) {
						stopTimer();
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
		},
		[stopTimer],
	);

	const resetTimer = useCallback(() => {
		stopTimer();
		setTimeLeft(0);
	}, [stopTimer]);

	const formatTime = useCallback((seconds: number): string => {
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
	}, []);

	return {
		timeLeft,
		startTimer,
		resetTimer,
		formatTime,
	};
};

export default useOtpTimer;
